export default "__VITE_ASSET__ftwgzc6L__"